import { createFileRoute } from "@tanstack/react-router";
import { FilesContent } from "@/features/study-group-files/components/FilesContent";

export const Route = createFileRoute("/study-group/$study-group-id/files")({
  component: FilesContent,
});
